import { getRgObjectsOfType as e, RG_TYPE as i } from "@project-rouge/rg-core";
import { getBuildingChildrenAtLevel as n } from "../../../utils/rg-util/index.js";
import { isBaseBuildObject as s } from "../../queries/index2.js";
import { isSingleDoor as g } from "../../queries/index8.js";
const d = (t, o) => {
  const r = e(t, i.Building), l = n(r, o).filter(s);
  return e(l, i.Door).filter(g).length;
};
export {
  d as getLevelBaseBuildSingleDoorsCount
};
//# sourceMappingURL=index7.js.map
